import { useBoolean, useMount, useRequest } from "ahooks";
import { message, Space, Spin } from "antd";
import { map } from "ramda";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";

import { Icon } from "@/components/icon";
import { IconTypes } from "@/components/icon/icons";
import { getPodcastPermissionApi } from "@/services/api/ai-podcast";

import styles from "./index.module.less";
type MenuItem = {
  key: string;
  icon: IconTypes;
  label: string;
  activeIcon: IconTypes;
  route: string;
};

const IntelligentCreationPage = () => {
  const { t } = useTranslation();

  const [menuIndex, setMenuIndex] = useState<string>();

  const [isGoBack, isGoBackActions] = useBoolean(false);

  const [loading, loadingActions] = useBoolean(false);

  const navigate = useNavigate();

  // 权限检查
  const { run: checkPermission } = useRequest(getPodcastPermissionApi, {
    manual: true,
    onSuccess: (response) => {
      if (!response?.data?.permission) {
        navigate("/");
      }
    },
    onError: (error) => {
      console.error("Permission check failed:", error);
      message.error(t("intelligent_creation.no_permission"));
      navigate("/");
    },
  });

  useMount(() => {
    setMenuIndex(menuList[0].key);
    // 检查权限
    checkPermission();
  });

  const menuList: MenuItem[] = [
    {
      key: "ai_podcast",
      label: t("intelligent_creation.ai_podcast"),
      icon: "tableTap",
      activeIcon: "tableTapActive",
      route: "/intelligent-creation/ai-podcast",
    },
  ];

  const handleToPage = (item: MenuItem) => {
    setMenuIndex(item.key);
    navigate(item.route);
  };

  return (
    <div className={styles.box}>
      {loading && (
        <Spin
          spinning
          size="large"
          className="absolute w-full h-full m-0 z-50 flex justify-center items-center "
        />
      )}
      <div className="w-11/12 h-full">
        <div className="my-3 h-20 relative w-full justify-center items-center flex bg-white rounded-2xl">
          <div
            className="absolute left-6 cursor-pointer font-black flex items-center"
            onClick={() => isGoBackActions.setTrue()}
          >
            <Icon icon="leftArrow" width={24} height={24} />
            <span className="text-lg ml-4">
              {t("intelligent_creation.intelligent_creation")}
            </span>
          </div>
          <Space size={64} align="center" className="text-base">
            {map(
              (item) => (
                <span
                  key={item.key}
                  className="flex items-center cursor-pointer"
                  onClick={() => handleToPage(item)}
                  style={{
                    color: menuIndex === item.key ? "var(--main-color)" : "",
                  }}
                >
                  <Icon
                    icon={item.key === menuIndex ? item.activeIcon : item.icon}
                  />
                  {item.label}
                </span>
              ),
              menuList
            )}
          </Space>
        </div>
        <Outlet context={{ isGoBack, isGoBackActions, loadingActions }} />
      </div>
    </div>
  );
};

export default memo(IntelligentCreationPage);
